export default "__VITE_ASSET__BTfkEqvf__"